<template>
  <div v-if="dialogVisible">
    <el-dialog :title="type ==='add' ? $t('lang.Button.Add') : $t('lang.Button.edit')" :visible.sync="dialogVisible" width="30%" center>
      <el-form :model="printerForm" label-width="130px" label-position="right">
         <el-form-item :label="`${$t('lang.PrinterDriver.printType')}：`">
          <el-input size="small" class="form-input" v-model="printerForm.ptype" :placeholder="$t('lang.PrinterDriver.printTypeInput')"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('lang.PrinterDriver.driveSign')}：`">
          <el-select class="form-input" size="small" v-model="printerForm.tag" :placeholder="$t('lang.PrinterDriver.driveSignSelect')">
            <el-option :label="$t('lang.PrinterDriver.common')" :value="0"></el-option>
            <el-option :label="$t('lang.PrinterDriver.special')" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.PrinterDriver.debugFlag')}：`">
          <el-select class="form-input" size="small" v-model="printerForm.dsymbol" :placeholder="$t('lang.PrinterDriver.debugFlagSelect')">
            <el-option :label="$t('lang.PrinterDriver.notDebugging')" :value="0"></el-option>
            <el-option :label="$t('lang.PrinterDriver.debuggingThrough')" :value="1"></el-option>
            <el-option :label="$t('lang.PrinterDriver.debuggingFailed')" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="`${$t('lang.PrinterDriver.printDrive')}：`" >
          <el-input size="small" v-model="printerForm.pdrive" :placeholder="$t('lang.PrinterDriver.printDriveInput')"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('lang.PrinterDriver.remark')}：`" >
          <el-input size="small"  v-model="printerForm.remark" :placeholder="$t('lang.PrinterDriver.remarkInput')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="hide()">{{$t('lang.Button.cancel')}}</el-button>
        <el-button size="small" type="primary" @click="submite">{{$t('lang.Button.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addPrinter, editPrinter } from '@/api/printer'
export default {
  data() {
    return {
      dialogVisible: false,
      type: '', // 操作类型，'add','edit'
      printerForm: { // 初始化字段，以防渲染DOM时找不到字段名报错
        id: '',
        pdrive: '',
        ptype: '',
        tag: 0,
        dsymbol: 0,
        remark: '',
      }
    }
  },
  methods: {
    // 初始化数据
    clearData() {
      this.printerForm = {
        id: '',
        pdrive: '',
        ptype: '',
        tag: 0,
        dsymbol: 0,
        remark: ''
      }
    },
    // 点击取消(需要清空数据，以防显示之前填写但并未提交的数据)
    hide(){
      this.clearData()
      this.dialogVisible = false
    },
    // 弹窗显示
    show(item) { 
      // 先清除数据
      this.clearData()
      if(item && item.id) { // 修改
        this.type = 'edit'
        // 显示待修改打印机的信息
        this.printerForm.id = item.id
        this.printerForm.pdrive = item.printDrive
        this.printerForm.ptype = item.printType
        this.printerForm.tag = item.tag 
        this.printerForm.dsymbol = item.dsymbol
        this.printerForm.remark = item.remark
      }else {
        this.type = 'add'
      } 
      this.dialogVisible = true
    },
    add() {
      // 添加时删除不必要的字段
      delete this.printerForm.id
      addPrinter(this.printerForm).then(res => {
        if(res.data.code === 0) {
          this.$message.success(this.$t('lang.Button.successAdd'))
          this.$emit('update')
          this.dialogVisible = false
        }else{
          res.data.error_message && this.$message.error(res.data.error_message)
        }
      }).catch(() =>{})
    },
    edit() {
      editPrinter(this.printerForm).then(res => {        
        if(res.data.code === 0) {
          this.$message.success(this.$t('lang.Button.successEdit'))
          this.$emit('update')
          this.dialogVisible = false
        }else{
          res.data.error_message && this.$message.error(res.data.error_message)
        }
      })
    },
    submite() {
      if(this.printerForm.id) { // 编辑
        this.edit()
      }else{
        this.add()
      }
    }
  }
}
</script>
<style scoped>
.footer{
  display: flex;
  justify-content: flex-end;
}
.form-input{
  width: 200px;
}
</style>